export default __webpack_public_path__ + "static/media/anatomyColoringSample.822672d8ec678c581dc42583e0a5af43.png";